<div class="tile-for-promotion-item -item-{{isEven ? 'even' : 'odd'}} -layout-{{layout ? layout : 'row'}}"
    id="promo-item-{{item?.Id}}" [ngClass]="{'-loading': isLoading, '-loaded': !isLoading}">
    <div class="tile-for-promotion-item__inner">

        <shared-thumb-for-promotion-item [layout]="layout" class="tile-for-promotion-item__thumb" [src]="item?.ImgURL"
            [loading]="isLoading">
        </shared-thumb-for-promotion-item>

        <div class="tile-for-promotion-item__bd">
            <shared-header type="3" [center]="centerHeader" marginBottom="sm" [loading]="isLoading">
                {{item?.Title}}
            </shared-header>

            <div class="tile-for-promotion-item__description">
                <ng-container *ngIf="!isLoading">
                    {{item?.Description}}
                </ng-container>

                <shared-loader-for-placeholder *ngIf="isLoading" class="tile-for-promotion-item__loader">
                </shared-loader-for-placeholder>
            </div>
        </div>


    </div>
</div>